window.addEventListener('load', function(){
    const landing = {
        landingResizeHandler: null as any,
        lazyLoadInstance: null as any,
        getJson(str: string){
            try {
                return JSON.parse(str);
            } catch (e) {
                console.log(e);
                return [];
            }
        },
        initPictures(){
            const pictures: NodeListOf<Element> = document.querySelectorAll('.glp-picture[data-version="2"]');
            this.setPictureSources(pictures);
            this.setPicturesHeights(pictures);
            window.addEventListener('resize', () => {
                this.landingResizeHandler && clearTimeout(this.landingResizeHandler);
                this.landingResizeHandler = setTimeout(() => {
                    landing.setPicturesHeights(pictures);
                }, 250);
            });
            this.initLazyLoad(pictures);
        },
        initLazyLoad(pictures: Array<Element>){
            const isLazy = typeof (window as any).LazyLoad != 'undefined';

            if (isLazy){
                for (let i = 0; i != pictures.length; ++i){
                    const img = pictures[i].querySelector('img');
                    img.classList.add('lazy');
                }
                if (this.lazyLoadInstance){
                    this.lazyLoadInstance.update();
                }
                else {
                    this.lazyLoadInstance = new (window as any).LazyLoad({
                        callback_loaded: function(el: Element){
                            const bnr = el.closest('.glp-banner');
                            if (bnr){
                                bnr.classList.remove('glp-uninit');
                            }
                        }
                    });
                }
            }
            else {
                for (let i = 0; i != pictures.length; ++i){
                    const img = pictures[i].querySelector('img');
                    const sources = pictures[i].querySelectorAll('source');

                    img.setAttribute('src', img.getAttribute('data-src'));
                    for (let x = 0; x != sources.length; ++x){
                        sources[x].setAttribute('srcset', sources[x].getAttribute('data-srcset'));
                    }
                }
            }
        },
        setPictureSources(pictures: NodeListOf<Element>){
            for (let i: number = 0; i != pictures.length; ++i){
                this.setSources(pictures[i]);
            }
        },
        setSources(picture: Element){
            const sources: NodeListOf<Element> = picture.querySelectorAll('source');
            const wString: string = picture.getAttribute('data-widths');
            const widths: Array<number> = this.getJson(wString) || [];
            const dString: string = picture.getAttribute('data-densities');
            const densities: object = this.getJson(dString) || [];

            for (let x: number = 0; x != sources.length; ++x){
                const url = sources[x].getAttribute('data-srcset');
                this.addSources(picture, url, widths, densities);
                sources[x].parentElement.removeChild(sources[x]);
            }
        },
        addSources(picture: Element, url: string, widths: Array<number>, densities: Array<number>){
            if (!widths.length || !densities.length) return;
            const srcsetAttr = this.lazyLoadInstance ? 'data-srcset' : 'srcset';
            const img = picture.querySelector('img');
            
            for (let y: number = 0; y != widths.length; ++y){
                for (let i = 0; i != densities.length; ++i){
                    const source = document.createElement('source');
                    let newUrl = url.replace('{width}', widths[y].toString());
                    
                    newUrl = newUrl.replace('{density}', densities[i].toString());
                    newUrl += ' ' + densities[i] + 'x';
                    source.setAttribute('media', '(max-width:' + widths[y] + 'px)');
                    source.setAttribute(srcsetAttr, newUrl);
                    picture.appendChild(source);
                }
            }
            if (img){
                img.parentElement.appendChild(img);
            }
        },
        setPicturesHeights(pictures: NodeListOf<Element>){
            for (let i: number = 0; i != pictures.length; ++i){
                const fullheightOffset: number = parseInt(pictures[i].getAttribute('data-fullheight'));
                
                if (!isNaN(fullheightOffset)) {
                    const head: Element = document.getElementById('agghead');
                    var headHeight: number = head.clientHeight;
                    var newHeight: string = 'calc(100vh - ' + (fullheightOffset + headHeight) + 'px)';
        
                    pictures[i].setAttribute('style', [
                        'display: flex',
                        'flex-direction: column',
                        'justify-content: center',
                        'overflow: hidden',
                        'height: ' + newHeight, 
                        'padding-bottom: 0'
                    ].join(';'));
                }
            }
        }
    }

    landing.initPictures();
    
});